import { render, staticRenderFns } from "./videoxq.vue?vue&type=template&id=75a44eee&scoped=true"
import script from "./videoxq.vue?vue&type=script&lang=js"
export * from "./videoxq.vue?vue&type=script&lang=js"
import style0 from "./videoxq.vue?vue&type=style&index=0&id=75a44eee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a44eee",
  null
  
)

export default component.exports